// Typed wrappers of the block view and the decisions on a blocked task (decision D37; apps/api/src/routes/block-decisions.ts),
// plus the task edit (PATCH /v1/tasks/{id}) and the test command edit (PATCH /v1/projects/{id} with the workspaces).
import type { BlockDecisionRequest, BlockDecisionResult, Task, TaskBlockView } from "@maestros/contracts";
import { api } from "./client.ts";

const enc = encodeURIComponent;

export const getTaskBlock = (taskId: string) => api<TaskBlockView>(`/tasks/${enc(taskId)}/block`);

export const decideBlock = (taskId: string, body: Partial<BlockDecisionRequest> & Pick<BlockDecisionRequest, "decision" | "expected_version">) =>
  api<BlockDecisionResult>(`/tasks/${enc(taskId)}/block-decisions`, { method: "POST", body });

export const updateTask = (taskId: string, body: { expected_version: number; title?: string; description?: string }) =>
  api<Task>(`/tasks/${enc(taskId)}`, { method: "PATCH", body });

export interface WorkspaceRow {
  id?: string;
  runner_id: string;
  operating_system: string;
  root_path: string;
  subpath: string;
  commands: Record<string, unknown>;
}

/**
 * Saves the test command of each workspace through the project PATCH. The command execution policy is never sent
 * (the API refuses it and carries the stored one over to the same workspace).
 */
export const saveTestCommands = (projectId: string, expectedVersion: number, workspaces: readonly WorkspaceRow[], tests: readonly string[]) =>
  api<unknown>(`/projects/${enc(projectId)}`, {
    method: "PATCH",
    body: {
      expected_version: expectedVersion,
      workspaces: workspaces.map((w, i) => {
        const { execution_policy: _policy, ...commands } = w.commands;
        const test = (tests[i] ?? "").trim();
        const next: Record<string, unknown> = { ...commands };
        if (test === "") delete next["test"];
        else next["test"] = test;
        return { runner_id: w.runner_id, operating_system: w.operating_system, root_path: w.root_path, subpath: w.subpath, commands: next };
      }),
    },
  });
